
import React from 'react';
import Logo from "../assets/images/logo.png";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import EuFlag from "../assets/images/eu_flag.png";
import {useUser} from "../Components/UserProvider";
import LogoutBox from "../Components/LogoutBox";
import { FormattedMessage } from 'react-intl';

export default function CreateProfileStart() {
    return <div className="d-flex flex-row flex-grow-1 align-items-center justify-content-center home">
        <div className="intro-center">
        
            <div className="bg">
                <Link to="/register/mentee"><Button color="primary"><FormattedMessage id="FIND_MENTOR" /></Button></Link>
                <Link to="/register/mentor"><Button color="primary"><FormattedMessage id="FIND_MENTEE" /></Button></Link>
            </div>

            <img src={EuFlag} className="erasmuslogo" alt="Erasmus+" />
        </div>
    </div>;
}
